import { useEffect, type PropsWithChildren } from 'react'
import { useLocation } from 'react-router-dom'
import { useSnapshot } from 'valtio'
import { authStore } from '../model/auth-store'
import {
  buildLocationTarget,
  redirectToLogin,
} from '../model/auth-navigation'
import { AuthPendingShell } from './auth-pending-shell'

export function ProtectedRoute({ children }: PropsWithChildren) {
  const location = useLocation()
  const { initialized, mode } = useSnapshot(authStore)
  const returnTo = buildLocationTarget(location)

  useEffect(() => {
    if (!initialized || mode === 'authenticated') {
      return
    }

    // 如果带有 communityId，则允许预览画布，不强行跳转登录
    // const searchParams = new URLSearchParams(location.search)
    // const isCommunityPreview = searchParams.has('communityId') || location.hash.includes('communityId=')

    // if (isCommunityPreview) {
    //   return
    // }

    redirectToLogin(returnTo)
  }, [initialized, mode, returnTo])
  // }, [initialized, mode, returnTo, location])

  if (!initialized) {
    return <AuthPendingShell />
  }

  if (mode === 'authenticated') {
    return <>{children}</>
  }

  const searchParams = new URLSearchParams(location.search)
  const isCommunityPreview = searchParams.has('communityId') || location.hash.includes('communityId=')

  if (isCommunityPreview) {
    return <>{children}</>
  }

  return <AuthPendingShell />
}
